/**
 * app-config/query-keys — CONFIG_OVER_CODE TanStack Query keys.
 *
 * Same contract as the rest: never inline arrays at the call site.
 */

export const appConfigQueryKeys = {
  all: ["app-config"] as const,
  /** `GET /api/config` — the config that the CLIENT reflects (public). */
  public: () => ["app-config", "public"] as const,
  /** `GET /api/admin/config` — env + overrides + resolved + catalog. */
  admin: () => ["admin", "app-config"] as const,
};
